import { useState } from "react";
import { SolanaWalletModalContext } from "../Contexts/useSolanaWalletModal";
import { SolanaWalletModal } from "../Components/SolanaWalletModal";

export function SolanaWalletModalProvider({ children, ...props }) {
    const [visible, setVisible] = useState(false);

    return (
        <SolanaWalletModalContext.Provider value={{ visible, setVisible }}>
            {children}
            {visible && <SolanaWalletModal {...props} />}
        </SolanaWalletModalContext.Provider>
    );
}
